export default "__VITE_ASSET__e99d82bc__"